module.exports = __webpack_public_path__ + "static/media/cart-plus.7899d227.svg";